/**
 * The country flags a player can fly, by the code PLAYER_NEW, PLAYER_FLAG and LOGIN's players carry: ISO 3166-1
 * alpha-2 codes, and a few that are not countries.
 */
export const FLAGS_CODE_TO_ISO = {
  '1': 'SY',
  '2': 'TH',
  '3': 'TM',
  '4': 'TN',
  '5': 'TR',
  '6': 'TT',
  '7': 'TW',
  '8': 'TZ',
  '9': 'UA',
  '10': 'UN',
  '11': 'US',
  '12': 'UY',
  '13': 'UZ',
  '14': 'VE',
  '15': 'VN',
  '16': 'PR',
  '17': 'PT',
  '18': 'PY',
  '19': 'QA',
  '20': 'RAINBOW',
  '21': 'RO',
  '22': 'RS',
  '23': 'RU',
  '24': 'SA',
  '25': 'SE',
  '26': 'SG',
  '27': 'SI',
  '28': 'SK',
  '29': 'SM',
  '30': 'MK',
  '31': 'MO',
  '32': 'MT',
  '33': 'MX',
  '34': 'MY',
  '35': 'NG',
  '36': 'NL',
  '37': 'NO',
  '38': 'NP',
  '39': 'NZ',
  '40': 'OM',
  '41': 'PA',
  '42': 'PE',
  '43': 'JP',
  '44': 'KP',
  '45': 'KR',
  '46': 'KW',
  '47': 'KZ',
  '48': 'LB',
  '49': 'LI',
  '50': 'LK',
  '51': 'LT',
  '52': 'LU',
  '53': 'LV',
  '54': 'HN',
  '55': 'HR',
  '56': 'HU',
  '57': 'ID',
  '58': 'IE',
  '59': 'IL',
  '60': 'IM',
  '61': 'IMPERIAL',
  '62': 'IN',
  '63': 'IQ',
  '64': 'DE',
  '65': 'DK',
  '66': 'DO',
  '67': 'DZ',
  '68': 'EC',
  '69': 'EE',
  '70': 'EG',
  '71': 'ES',
  '72': 'EU',
  '73': 'BH',
  '74': 'BO',
  '75': 'BR',
  '76': 'BT',
  '77': 'BY',
  '78': 'CA',
  '79': 'CH',
  '80': 'AD',
  '81': 'AE',
  '82': 'AL',
  '83': 'AM',
  '84': 'CL',
  '85': 'AQ',
  '86': 'CN',
  '87': 'AR',
  '88': 'FI',
  '89': 'CO',
  '90': 'AT',
  '91': 'IR',
  '92': 'FR',
  '93': 'COMMUNIST',
  '94': 'AU',
  '95': 'LY',
  '96': 'IS',
  '97': 'GB',
  '98': 'CONFEDERATE',
  '99': 'AZ',
  '100': 'MA',
  '101': 'IT',
  '102': 'GE',
  '103': 'CR',
  '104': 'BA',
  '105': 'PH',
  '106': 'MC',
  '107': 'JM',
  '108': 'GR',
  '109': 'CU',
  '110': 'BD',
  '111': 'SO',
  '112': 'PK',
  '113': 'MD',
  '114': 'JO',
  '115': 'GT',
  '116': 'CY',
  '117': 'BE',
  '118': 'ZA',
  '119': 'SV',
  '120': 'PL',
  '121': 'ME',
  '122': 'JOLLY',
  '123': 'HK',
  '124': 'CZ',
  '125': 'BG',
} as const;

/** The flag codes by ISO code, for the name a client sends in its LOGIN. */
export const FLAGS_ISO_TO_CODE: Readonly<Record<string, number>> = /* @__PURE__ */ Object.fromEntries(
  Object.entries(FLAGS_CODE_TO_ISO).map(([code, iso]) => [iso, Number(code)]),
);
